import { API_URL } from "../enviroment/enviroment";
import api from "src/api/axios";

const createRoutePoint = async (input) => {
  return api.post(`/points`, input).then((result) => {
    return result.data;
  });
};

const createBulkRoutePoint = async (input) => {
  return api.post(`/points/bulk-create`, input).then((result) => {
    return result.data;
  });
};

const updateRoutePoint = async (input, id) => {
  return api.patch(`/points/${id}`, input).then((result) => {
    return result.data;
  });
  a;
};

const updateActiveStatus = async (input, id) => {
  return api.patch(`/points/active-inactive/${id}`, input).then((result) => {
    return result.data;
  });
};

const getRoutePointList = async ({ page = 1, limit = 10, q, country }) => {
  const params = new URLSearchParams({
    page,
    limit,
  });
  if (q) params.append("q", q);
  if (country) params.append("country", country);

  return api.get(`/points?${params}`).then((result) => {
    return result.data;
  });
};

const getSingleRoutePoint = async (id) => {
  return api.get(`/points/${id}`).then((result) => {
    return result.data;
  });
};

export {
  createRoutePoint,
  getRoutePointList,
  getSingleRoutePoint,
  updateRoutePoint,
  updateActiveStatus,
  createBulkRoutePoint,
};
